import styled from "styled-components";
import { COLORS, LIGHT_THEME_COLORS } from "styles/colors";
import { FLEX } from "styles/flex";
import NotFound from "assets/images/404-error.png";
import { calcRem } from "styles/theme";
import BigButton from "components/atoms/buttons/BigButton";
import * as mediaQuery from "components/MediaQuery";

export default function ErrorBox({
  title,
  subtitle,
  children,
  onReturn,
  message,
  buttonLabel,
}: {
  title?: string;
  subtitle?: string;
  children: React.ReactNode;
  onReturn: () => void;
  message?: string;
  buttonLabel?: string;
}): JSX.Element {
  return (
    <Wrapper>
      <Inner>
        {(title || subtitle) && (
          <div className="title">
            {title && <h1>{title}</h1>}
            {subtitle && <span>{subtitle}</span>}
          </div>
        )}

        <Contents>
          <div className="img-wrapper">
            <img src={NotFound} alt="not_found_page_icon" />
          </div>
          <div className="text-wrapper">
            {message && <h3>{message}</h3>}
            {children}
            <BigButton
              label={buttonLabel || "Return to myDW"}
              onClickBtn={onReturn}
              data-testid="blocks-error-error-button-return"
            />
          </div>
        </Contents>
      </Inner>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  width: 100%;
  ${FLEX.FlexCenterCenter};
  padding: 50px;
`;

const Inner = styled.div`
  ${FLEX.FlexStartCenter};
  flex-direction: column;
  color: ${COLORS.BORDER};
  background-color: ${({ theme }) =>
    theme.value === "light" ? LIGHT_THEME_COLORS.LIGHTGRAY : COLORS.PRIMARY1};
  padding: 30px 50px;
  border-radius: 6px;
  width: 800px;
  height: max-content;

  .title {
    width: 100%;
    padding-bottom: 20px;
    border-bottom: 1px solid ${COLORS.BORDER};
    font-size: ${calcRem(18)};
    color: ${COLORS.LIGHTGRAY};

    > h1 {
      color: ${({ theme }) => theme.COLORS.WHITE};
      font-weight: 400;
      font-size: ${calcRem(40)};
      margin-bottom: 8px;
    }

    ${mediaQuery.isMobile} {
      text-align: center;
    }
  }
`;

const Contents = styled.div`
  width: 100%;
  padding-top: 40px;
  ${FLEX.FlexBetweenStart};
  gap: 20px;

  ${mediaQuery.isDefault} {
    height: 250px;
  }

  ${mediaQuery.isMobile} {
    flex-direction: column;
    align-items: center;
  }

  .img-wrapper {
    ${mediaQuery.isDefault} {
      flex: 1;
      flex-direction: column;
      height: 100%;
    }
    ${mediaQuery.isMobile} {
      flex-direction: column;
      height: 100px;
    }

    > img {
      height: 100%;
    }
  }

  .text-wrapper {
    flex: 1.5;
    ${FLEX.FlexBetweenStart};
    flex-direction: column;
    color: ${COLORS.LIGHTGRAY};
    font-size: ${calcRem(15)};
    line-height: ${calcRem(18)};

    h3 {
      color: ${({ theme }) => theme.COLORS.WHITE};
      font-size: ${calcRem(24)};
      font-weight: 400;
    }

    button {
      width: 100%;
    }

    ${mediaQuery.isDefault} {
      height: 100%;
    }

    ${mediaQuery.isMobile} {
      align-items: center;
      text-align: center;
      gap: 10px;
    }
  }
`;
